import { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext({
  dynamicLabels: {},
  setDynamicLabel: () => {},
});

export function BreadcrumbProvider({ children }) {
  const [dynamicLabels, setDynamicLabels] = useState({});

  const setDynamicLabel = useCallback((paramKey, label) => {
    setDynamicLabels(prev => {
      if (prev[paramKey] === label) return prev;
      return { ...prev, [paramKey]: label };
    });
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ dynamicLabels, setDynamicLabel }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbContext() {
  return useContext(BreadcrumbContext);
}
